module.exports = __webpack_public_path__ + "img/BokharW.79be1ba7.jpg";